<template>
  <div id="main-header">
    <div class="ui menu">
      <router-link to="/"
                   id="esp-logo"
                   class="item">
        <img class="ui image"
             src="../assets/images/ESP/esp-globe-purple.png">
        <img class="ui image"
             src="../assets/images/ESP/esp-logo-purple.png">
      </router-link>

      <div id="page-title"
           class="item">
        <h1 v-if="$root.currentView">
          <i :class="$root.currentView.icon + ' icon'"></i>
          <span v-html="$root.currentView.label"></span>
        </h1>
      </div>

      <div class="right menu">

        <div class="icon item"
             v-if="showNotificationsIcon">
          <i class="large orange bell gts-btn icon"
             id="adv-msgs-icon"
             title="View Notifications"
             @click="showAdvMsgs"></i>
        </div>

        <div class="ui dropdown centered item"
             id="signed-in-user">
          <div class="text">
            {{ currentUserFullName }}
            <div id="user-role">{{ currentUserHighestRole }}</div>
          </div>
          <i class="dropdown icon"></i>
          <div class="menu">
            <router-link class="item"
                         to="/">
              <i class="home icon"></i>Home
            </router-link>

            <div class="divider"
                 v-if="$root.tasks.Features"></div>

            <router-link v-for="t in $root.tasks.Features"
                         :key="t.label"
                         class="item"
                         :class="{ 'disabled' : t.disabled }"
                         :id="t.name"
                         :to="t.route">
              <i :class="t.icon + ' icon'"></i>
              {{ t.label }}
            </router-link>

            <div class="divider"
                 v-if="$root.tasks.Vouchers"></div>

            <router-link v-for="t in $root.tasks.Vouchers"
                         :key="t.label"
                         class="item"
                         :class="{ 'disabled' : t.disabled }"
                         :id="t.name"
                         :to="t.route">
              <i :class="t.icon + ' icon'"></i>
              {{ t.label }}
            </router-link>

            <div class="divider"
                 v-if="claimSandboxTask || referenceGuideTask"></div>

            <router-link v-if="claimSandboxTask"
                         class="item"
                         :id="claimSandboxTask.name"
                         :to="claimSandboxTask.route">
              <i :class="claimSandboxTask.icon + ' icon'"></i>
              <span class="ui purple sub header">{{ claimSandboxTask.label }}</span>
            </router-link>

            <router-link v-if="referenceGuideTask"
                         class="item"
                         :id="referenceGuideTask.name"
                         :to="referenceGuideTask.route">
              <i :class="referenceGuideTask.icon + ' icon'"></i>
              <span class="ui green sub header">{{ referenceGuideTask.label }}</span>
            </router-link>

            <div class="divider"
                 v-if="$root.tasks.Management"></div>

            <router-link v-for="t in $root.tasks.Management"
                         :key="t.label"
                         class="item"
                         :id="t.name"
                         :to="t.route">
              <i :class="t.icon + ' icon'"></i>
              {{ t.label }}
            </router-link>

            <div class="divider"
                 v-if="adminTasks"></div>

            <router-link class="item"
                         :id="adminTasks[0].name"
                         :to="adminTasks[0].route"
                         v-if="adminTasks">
              <i :class="adminTasks[0].icon + ' icon'"></i>
              <span class="ui blue sub header">{{ adminTasks[0].label }}</span>
              <!-- BELOW IS SUBMENU OPTION -->
              <!-- <i class="left dropdown icon"
                 style="margin-right: 1.6rem;"></i>
              <div class="text">
                <span class="ui blue sub header">{{ adminTasks[0].label }}</span>
              </div>
              <div class="left menu">
                <router-link v-for="t in adminSubTasks"
                             :key="t.label"
                             class="item"
                             :id="t.name"
                             :to="t.route">
                  <i :class="t.icon + ' icon'"></i>
                  {{ t.label }}
                </router-link>
              </div> -->
            </router-link>

            <div class="divider"></div>

            <a id="contact-us--menu"
               class="item"
               target="_blank"
               :href="serviceDeskURL">
              <i class="primary comment dots icon"></i>
              <span class="ui primary sub header">Contact Us</span>
            </a>

            <a id="faq--menu"
               class="item"
               target="_blank"
               href="//espsupport.globetax.com">
              <i class="primary question circle outline icon"></i>
              <span class="ui primary sub header">FAQ</span>
            </a>

            <div class="divider"></div>

            <a class="item"
               @click="$root.signOutCurrentUser"
               :id="signOutTask.name">
              <i :class="signOutTask.icon + ' icon'"></i>
              {{ signOutTask.label }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    currentUserFullName() {
      let _user = this.$root.currentUser
      return _user.firstName + ' ' + _user.lastName
    },
    currentUserHighestRole() {
      return this.$root.currentUserHighestRoleAcrossDTCC.roleName
    },
    adminTasks() {
      let _adminTasks =
        this.$root.tasks.Admin && this.$root.tasks.Admin?.length > 1
          ? this.$root.tasks.Admin
          : null

      return _adminTasks
    },
    adminSubTasks() {
      return this.$root.tasks.Admin && this.$root.tasks.Admin?.length > 1
        ? this.$root.tasks.Admin.slice(1)
        : null
    },
    claimSandboxTask() {
      return this.$root.tasks.ClaimSandbox
        ? this.$root.tasks.ClaimSandbox[0]
        : null
    },
    referenceGuideTask() {
      return this.$root.tasks.ReferenceGuide
        ? this.$root.tasks.ReferenceGuide[0]
        : null
    },
    serviceDeskURL() {
      return SERVICE_DESK_URL
    },
    signOutTask() {
      return this.$root.tasks.SignOut[0]
    },
    showNotificationsIcon() {
      if (this.$root.pageSpecificMessages)
        return !!Object.keys(this.$root.pageSpecificMessages).length
      else return false
    },
  },
  methods: {
    showAdvMsgs() {
      return this.$root.showCurrentPathAdvisoryMessages(true)
    },
  },
  mounted() {
    $('#signed-in-user').dropdown({
      on: 'hover',
      action: 'select',
    })
  },
}
</script>

<style lang="stylus">
#main-header {
  position: relative;

  & > .ui.menu {
    background: $gts-lightgray;
    vendor(border-radius, 0);
  }
}

#signed-in-user,
#esp-logo {
  background-color: transparentify(#fff, 5%) !important;
  vendor(border-radius, 0);

  &:hover {
    background-color: transparentify(#fff, 95%) !important;
  }
}

#user-role {
  margin-top: 0.25rem;
  text-align: center;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 300;
  color: $lightgray-color;
}

#esp-logo {
  img:first-child {
    width: 2.5rem;
    margin-right: 1rem;
  }

  img:last-child {
    width: 4.5rem;
    height: 1.75rem;
    margin-top: 2px;
  }
}

#page-title {
  padding-left: 1.5rem;

  &:before {
    width: 0 !important;
  }

  h1 {
    text-transform: uppercase;
    color: $gts-text-color !important;

    & > i {
      margin-right: 0.75rem;
      vertical-align: baseline;
    }
  }

  h1,
  i {
    text-shadow();
  }
}

#signed-in-user {
  font-weight: bold;

  .menu > .divider {
    margin: 0;
  }

  .menu {
    z-index: 9999;
  }
}

/* custom to match other icons width */
.ui.dropdown > .menu > .item > i.file.image.icon {
  width: 1.18em;
}
</style>